import React from "react";

import marketReadyImg from "../../../assets/Images/about/market-ready.png";
import flexibleBrandingImg from "../../../assets/Images/about/flexible-branding.png";
import expertCareImg from "../../../assets/Images/about/expert-care-compassionate-support-success-2.png";

const Fifth_Aboutus_Section = () => {
  return (
    <section className="w-full bg-white py-16 sm:py-20 overflow-hidden">

      {/* INLINE CSS */}
      <style>{`
        .gradient-text {
          background: linear-gradient(135deg, #355931 0%, #A4BE2C 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .feature-card {
          transition: all 0.4s ease;
        }

        .feature-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 50px rgba(0,0,0,0.08);
        }

        .feature-card img {
          transition: transform 0.5s ease;
        }

        .feature-card:hover img {
          transform: scale(1.08);
        }

        .main-image img {
          transition: transform 0.7s ease;
        }

        .main-image:hover img {
          transform: scale(1.03);
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">

          {/* LEFT CONTENT */}
          <div>

            {/* Small Label */}
            <p className="text-[#A4BE2C] tracking-[0.35em] text-[11px] font-semibold mb-4 uppercase">
              PRIVATE LABEL SOLUTIONS
            </p>

            {/* Main Heading */}
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-serif text-[#355931] leading-tight">
              Make Your Brand <br />
              <span className="gradient-text">
                Stand Out
              </span>
            </h2>

             {/* Underline */}
            <div
              className="
                w-24
                h-[2px]
                mt-6
                mb-6
                dw-fade-up
              "
              style={{
                animationDelay: "240ms",
                background:
                  "linear-gradient(90deg, transparent 0%, #355931 30%, #A4BE2C 70%, transparent 100%)",
              }}
            />

            {/* Description */}
            <p className="text-gray-600 text-sm sm:text-base leading-relaxed max-w-2xl">
              Looking to create high-quality nutritional products under your
              own label? Nutralike Private Label Services empowers brands with
              end-to-end support - from formulation and manufacturing to
              packaging and market-ready solutions.
            </p>

            {/* FEATURE CARDS */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-10">

              {/* CARD 1 */}
              <div className="feature-card border border-[#e7eee2] rounded-[28px] p-6 bg-white">

                <div className="mb-6">
                  <img
                    src={marketReadyImg}
                    alt="Market Ready"
                    className="w-16 h-16 object-contain"
                  />
                </div>

                <h3 className="text-xl font-serif text-[#355931] mb-3 leading-snug">
                  MARKET READY
                </h3>

                <p className="text-gray-600 text-sm leading-relaxed">
                  From formulation to packaging, we simplify every stage of
                  product development for faster market launches.
                </p>

              </div>

              {/* CARD 2 */}
              <div className="feature-card border border-[#e7eee2] rounded-[28px] p-6 bg-white">

                <div className="mb-6">
                  <img
                    src={flexibleBrandingImg}
                    alt="Flexible Branding"
                    className="w-16 h-16 object-contain"
                  />
                </div>

                <h3 className="text-xl font-serif text-[#355931] mb-3 leading-snug">
                  FLEXIBLE BRANDING
                </h3>

                <p className="text-gray-600 text-sm leading-relaxed">
                  Fully customizable branding and packaging solutions tailored
                  to reflect your unique business identity.
                </p>

              </div>

            </div>

          </div>

          {/* RIGHT IMAGE */}
          <div className="hidden lg:block">

            <div className="main-image rounded-[36px] overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.08)]">

              <img
                src={expertCareImg}
                alt="Nutralike Private Label Services"
                className="w-full h-auto object-cover cursor-default pointer-events-none"
              />

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default Fifth_Aboutus_Section;